var _style, _g, _g2, _polygon, _polygon2, _path, _circle, _polyline, _polyline2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardsBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.6 108.9",
    style: {
      enableBackground: "new 0 0 99.6 108.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1A3D1E;}\r\n\t.st1{fill:#5CA645;}\r\n\t.st2{fill:#E7F3E3;}\r\n\t.st3{fill:#ADD136;}\r\n\t.st4{fill:#6AB54E;}\r\n\t.st5{opacity:0.4;fill:#FFFFFF;}\r\n\t.st6{opacity:0.85;fill:#FDFEFE;}\r\n\t.st7{opacity:0.3;fill:#FFFFFF;}\r\n\t.st8{opacity:0.85;fill:#FFFFFF;}\r\n\t.st9{fill:url(#SVGID_1_);}\r\n\t.st10{fill:url(#SVGID_2_);}\r\n\t.st11{fill:url(#SVGID_3_);}\r\n\t.st12{fill:url(#SVGID_4_);}\r\n\t.st13{fill:url(#SVGID_5_);}\r\n\t.st14{fill:#FFF4F0;}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.9,9.3h73.8c7.1,0,12.9,5.8,12.9,12.9v73.8c0,7.1-5.8,12.9-12.9,12.9H12.9C5.8,108.9,0,103.2,0,96.1V22.2 C0,15.1,5.8,9.3,12.9,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.9,4.5h73.8c7.1,0,12.9,5.8,12.9,12.9v73.8c0,7.1-5.8,12.9-12.9,12.9H12.9C5.8,104.1,0,98.4,0,91.2V17.4 C0,10.3,5.8,4.5,12.9,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.9,0h73.8c7.1,0,12.9,5.8,12.9,12.9v73.8c0,7.1-5.8,12.9-12.9,12.9H12.9C5.8,99.6,0,93.8,0,86.7V12.9 C0,5.8,5.8,0,12.9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.4,6.1h64.7c6.2,0,11.3,5.1,11.3,11.3v64.7c0,6.2-5.1,11.3-11.3,11.3H17.4c-6.2,0-11.3-5.1-11.3-11.3V17.4 C6.1,11.2,11.2,6.1,17.4,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38,86.1l18.6-0.6c39.2-3.8,36.8-49.9,36.8-43.7v40.4c0,6.2-5.1,11.3-11.3,11.3H17.4 c-6.2,0-11.3-5.1-11.3-11.3v-7.4C17.2,83.7,18.6,86.1,38,86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M17.4,6.1h64.7c6.2,0,11.3,5.1,11.3,11.3v3.2c0,6.2-1.9-8.6-11.3-8.6H17.4C8.2,12,6.1,26.9,6.1,20.6v-3.2 C6.1,11.2,11.2,6.1,17.4,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M25.7,9.9c0,0-5.1-2.8-8.8,0s-4,6.5-3,8.6c1,1.8,2.7,1.6,4.1-1.7s5.4-3.9,5.4-3.9S27.5,12.7,25.7,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M75.2,85.4l8.1-3.3c1.9-0.8,4-0.1,4.7,1.5v0c0.7,1.6-0.3,3.6-2.2,4.4l-8.1,3.3c-1.9,0.8-4,0.1-4.7-1.5v0 C72.3,88.2,73.3,86.2,75.2,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M90.1,80.9l1.1-0.4c0.4-0.2,1.5,0,1.7,0.6v0c0.3,0.6-0.2,1.4-0.7,1.6l-1.1,0.4c-0.4,0.2-1.5,0-1.8-0.6v0 C89.1,81.9,89.6,81.1,90.1,80.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M9.4,24.4l0.9-1.6c0.4-0.7,1.8-1.4,2.7-0.9l0,0c0.9,0.5,1.1,2,0.7,2.6l-0.9,1.6c-0.4,0.7-1.8,1.5-2.7,0.9l0,0 C9.1,26.6,9,25.1,9.4,24.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "47.3,72.2 29.4,90 26.1,79.9 16,76.6 33.8,58.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "55.1,72.2 72.9,90 76.2,79.9 86.4,76.6 68.5,58.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.4,50.2c0,2.9-4.4,5.1-5.2,7.8c-0.9,2.7,1.3,7.1-0.4,9.4c-1.7,2.3-6.5,1.5-8.8,3.2 c-2.3,1.7-3,6.5-5.8,7.4c-2.6,0.9-6.1-2.6-9-2.6c-2.9,0-6.4,3.4-9,2.6c-2.7-0.9-3.5-5.7-5.8-7.4c-2.3-1.7-7.1-0.9-8.8-3.2 c-1.7-2.3,0.5-6.6-0.4-9.4c-0.9-2.6-5.2-4.9-5.2-7.8c0-2.9,4.4-5.1,5.2-7.8c0.9-2.7-1.3-7.1,0.4-9.4c1.7-2.3,6.5-1.5,8.8-3.2 c2.3-1.7,3-6.5,5.8-7.4c2.6-0.9,6.1,2.6,9,2.6c2.9,0,6.4-3.4,9-2.6c2.7,0.9,3.5,5.7,5.8,7.4c2.3,1.7,7.1,0.9,8.8,3.2 c1.7,2.3-0.5,6.6,0.4,9.4C76,45.1,80.4,47.3,80.4,50.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 51.2,
    cy: 50.2,
    r: 21.2
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "46.3,45.5 35.8,46.9 43.2,54.4 41.4,64.8 51.1,59.8 60.5,64.8 58.2,54.7 65.7,47 55.9,45.5 50.7,36  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "46.3,44.4 35.8,45.8 43.2,53.3 41.4,63.7 51.1,58.7 60.5,63.7 58.2,53.6 65.7,45.9 55.9,44.4  50.7,34.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -166.9693,
    y1: -3.0397,
    x2: -132.8891,
    y2: -3.0397,
    gradientTransform: "matrix(0.4524 -0.4524 0.7071 0.7071 102.3335 5.7426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00406504,
    style: {
      stopColor: "#F15C70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B11E47"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "47.3,70 29.4,87.8 26.1,77.7 16,74.4 33.8,56.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -204.0763,
    y1: -26.7806,
    x2: -169.9961,
    y2: -26.7806,
    gradientTransform: "matrix(-0.4524 -0.4524 -0.7071 0.7071 -33.5647 5.7426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00406504,
    style: {
      stopColor: "#F15C70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B11E47"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "55.1,70 72.9,87.8 76.2,77.7 86.4,74.4 68.5,56.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.1716,
    y1: 20.3637,
    x2: 51.1716,
    y2: 73.8334
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDE37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F89839"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M80.4,48c0,2.9-4.4,5.1-5.2,7.8c-0.9,2.7,1.3,7.1-0.4,9.4c-1.7,2.3-6.5,1.5-8.8,3.2 c-2.3,1.7-3,6.5-5.8,7.4c-2.6,0.9-6.1-2.6-9-2.6c-2.9,0-6.4,3.4-9,2.6c-2.7-0.9-3.5-5.7-5.8-7.4c-2.3-1.7-7.1-0.9-8.8-3.2 c-1.7-2.3,0.5-6.6-0.4-9.4c-0.9-2.6-5.2-4.9-5.2-7.8c0-2.9,4.4-5.1,5.2-7.8c0.9-2.7-1.3-7.1,0.4-9.4c1.7-2.3,6.5-1.5,8.8-3.2 c2.3-1.7,3-6.5,5.8-7.4c2.6-0.9,6.1,2.6,9,2.6c2.9,0,6.4-3.4,9-2.6c2.7,0.9,3.5,5.7,5.8,7.4c2.3,1.7,7.1,0.9,8.8,3.2 c1.7,2.3-0.5,6.6,0.4,9.4C76,42.9,80.4,45.1,80.4,48z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.1716,
    y1: 73.0662,
    x2: 51.1716,
    y2: 23.9323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEDE37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F89839"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 51.2,
    cy: 48,
    r: 21.2
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.8348,
    y1: 48.2122,
    x2: 65.7157,
    y2: 48.2122
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00406504,
    style: {
      stopColor: "#F15C70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B11E47"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "46.3,43.3 35.8,44.7 43.2,52.2 41.4,62.6 51.1,57.6 60.5,62.6 58.2,52.5 65.7,44.8 55.9,43.3  50.7,33.8  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st14",
    points: "46.3,42.2 35.8,43.6 43.2,51.1 41.4,61.5 51.1,56.5 60.5,61.5 58.2,51.4 65.7,43.7 55.9,42.2  50.7,32.7  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsBtn);
export default __webpack_public_path__ + "static/media/rewards-btn.14a42af031e608f7990d23ffc0164e97.svg";
export { ForwardRef as ReactComponent };